'use strict';

exports.__esModule = true;
exports.blogBanner = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _blogBanner = require('../actions/blog-banner');

var _blogBanner2 = require('../transformers/blog-banner');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GET_BLOG_POSTS_RECEIVED = _blogBanner.GET_BLOG_POSTS + '_RECEIVED';
var GET_BLOG_MEDIA_RECEIVED = _blogBanner.GET_BLOG_MEDIA + '_RECEIVED';
var GET_BLOG_POST_CATEGORIES_RECEIVED = _blogBanner.GET_BLOG_POST_CATEGORIES + '_RECEIVED';
var GET_BLOG_AUTHORS_RECEIVED = _blogBanner.GET_BLOG_AUTHORS + '_RECEIVED';
var GET_SPECIALISTS_BLOG_AUTHORS_RECEIVED = _blogBanner.GET_SPECIALISTS_BLOG_AUTHORS + '_RECEIVED';
var GET_AUTHOR_INFO_RECEIVED = _blogBanner.GET_AUTHOR_INFO + '_RECEIVED';

var INITIAL_STATE = { blogAuthors: [], specialistBlogAuthors: [], selectedIndex: 0, posts: [], postMedia: {} };

var blogBanner = exports.blogBanner = function blogBanner(state, action) {
	switch (action.type) {
		case GET_BLOG_AUTHORS_RECEIVED:
			{
				return (0, _assign2.default)({}, state, { blogAuthors: action.response });
			}
		case GET_SPECIALISTS_BLOG_AUTHORS_RECEIVED:
			return (0, _assign2.default)({}, state, { specialistBlogAuthors: action.response.specialists });
		case _blogBanner.UPDATE_INDEX:
			return (0, _assign2.default)({}, state, { selectedIndex: action.index });
		case GET_BLOG_POSTS_RECEIVED:
			{
				return (0, _assign2.default)({}, state, { posts: (0, _blogBanner2.transformPosts)(action.response) });
			}
		case GET_BLOG_MEDIA_RECEIVED:
			{
				return (0, _assign2.default)({}, state, { posts: (0, _blogBanner2.transformPostsMedia)(state.posts, action.response) });
			}
		case GET_BLOG_POST_CATEGORIES_RECEIVED:
			return (0, _assign2.default)({}, state, { posts: (0, _blogBanner2.transformPostsCategories)(state.posts, action.response) });
		case GET_AUTHOR_INFO_RECEIVED:
			return (0, _assign2.default)({}, state, { posts: (0, _blogBanner2.transformPostsAuthors)(state.posts, action.response) });
		default:
			return state || INITIAL_STATE;
	}
};


// WEBPACK FOOTER //
// ./components/home-page/lib/reducers/blog-banner.js